import React from "react"
import '../../css/style.css'

import Header from "../components/header"
import Footer from "../components/footer"

export default function Service() {
    return (
      <div id="page">
        <Footer />
        <Header />

        <div id="page-wrapper">
            <div className="container">    
                <div class="col-md-12">
                    <div class="service-header">
                        <h1>Service Price</h1>
                        <p>When you Fix more than 2 Parts, There is special Discount. Enquiry NOW!</p>
                    </div>
                </div>

                <div className="service-container">
                    <h2>iPhone Screen Replacement</h2>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>iPhone 5/5s</p>
                                <p>iPhone SE (2016)</p>
                                <p>iPhone 6</p>
                                <p>iPhone 6 Plus</p>
                                <p>iPhone 6s</p>
                                <p>iPhone 6s Plus</p>
                                <p>iPhone 7</p>   
                                <p>iPhone 7 Plus</p>
                                <p>iPhone SE 2 (2020)</p>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>iPhone 8</p>
                                <p>iPhone 8 Plus</p>
                                <p>iPhone X</p>
                                <p>iPhone XS</p>
                                <p>iPhone XR</p>
                                <p>iPhone XS Max</p>
                                <p>iPhone 11</p>
                                <p>iPhone 11 Pro</p>
                                <p>iPhone 11 Pro Max</p>
                            </div>
                        </div>
                    </div>

                    <h2>iPad Screen Replacement</h2>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>iPad 2</p>
                                <p>iPad 3</p>
                                <p>iPad 4</p>
                                <p>iPad 5</p>
                                <p>iPad 6</p>
                                <p>iPad 7</p>
                                <p>iPad Pro Series</p>
                            </div>
                        </div>

                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>iPad Mini 1</p>
                                <p>iPad Mini 2</p>
                                <p>iPad Mini 3</p>
                                <p>iPad Mini 4</p>
                                <p>iPad Mini 5</p>
                                <p>iPad Air 1</p>
                                <p>iPad Air 2</p>
                                <p>iPad Air 3</p>
                            </div>
                        </div>
                    </div>

                    <h2>iPhone Battery Replacement</h2>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>iPhone 5 / 5S / SE</p>
                                <p>iPhone 6 / 6 Plus</p>
                                <p>iPhone 6S / 6S Plus</p>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>iPhone 7 / 7 Plus</p>
                                <p>iPhone 8 / 8 Plus</p>
                                <p>iPhone X / XS / XR / XS Max</p>
                            </div>
                        </div>
                    </div>

                    <h2>Other Parts</h2>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>Front Camera</p>
                                <p>Ear Speaker</p>
                                <p>Loud Speaker</p>
                                <p>Back Glass Housing</p>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="service-content">
                                <p>Rear Camera</p>
                                <p>Home Button</p>
                                <p>Charging Port</p>
                                <p>Camera Lens (Glass)</p>
                            </div>
                        </div>
                    </div>
                </div>
         
            </div>
        </div>
      </div>
    ) 
  }